<template>
  <div class="page_box">
    <div class="page_option_box">
      <div class="option_box">
        <el-button
            type="primary"
            plain
            @click="addClick"
            size="mini"
            icon="el-icon-circle-plus-outline"
          >
            新增
          </el-button>
          <el-button
            type="danger"
            plain
            @click="deleteClick('all', idsList)"
            size="mini"
            icon="el-icon-circle-close"
            :disabled="idsList.length < 1 ? true : false"
          >
            删除
          </el-button>
      </div>
      <div class="search_box">
        <el-input
            class="select-input"
            v-model.trim="requestData.className"
            placeholder="请输入班级名称"
            clearable
            size="mini"
          ></el-input>
          &nbsp;&nbsp;
          <el-input
            class="select-input"
            v-model.trim="requestData.classTeacher"
            placeholder="请输入老师名称"
            clearable
            size="mini"
          ></el-input>
          &nbsp;&nbsp;
          <el-input
            class="select-input"
            v-model.trim="requestData.emergencyContactName"
            placeholder="请输入紧急联络人"
            clearable
            size="mini"
          ></el-input>
          &nbsp;&nbsp;
          <el-button
            size="mini"
            type="primary"
            plain
            icon="el-icon-search"
            @click="searchList"
            >搜索</el-button
          >
      </div>
    </div>
    <div class="page_table_box">
      <div class="school_table_box">
        <el-table
          :data="tableData"
          height="100%"
          class="table_box"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
          @selection-change="selectActionData"
        >
          <el-table-column type="selection" width="40" align="center">
          </el-table-column>
          <el-table-column label="序号" width="70" align="center">
            <template slot-scope="scope">
              {{
                requestData.pageSize * (requestData.pageNum - 1) +
                  scope.$index +
                  1
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="className"
            label="班级名称"
            width="120"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="classTeacher"
            label="班主任"
            width="120"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="emergencyContactName"
            label="紧急联系人"
            width="120"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="emergencyContactPhone"
            label="	紧急联系人方式"
            width="160"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="timeLastEpisode"
            label="最近发病时间"
            width="120"
            align="center"
          >
            <template slot-scope="rowData">
              {{ $Common.dateFormatDate(rowData.row.timeLastEpisode) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="incidence"
            label="发病情况"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="instructionManual"
            label="备注说明"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
          <el-table-column label="操作" width="180" align="center">
            <template slot-scope="scope">
              <el-link
                class="link_box"
                type="primary"
                :underline="false"
                @click="editClick(scope.row)"
                >编辑</el-link
              >
              <el-divider direction="vertical"></el-divider>
              <el-link
                class="link_box"
                type="primary"
                :underline="false"
                @click="deleteClick('single', [scope.row.id])"
                >删除</el-link
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination_box">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="requestData.pageNum"
          :page-size="requestData.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <add-or-edit
      :drawerShow="drawerShow"
      :drawerType="drawerType"
      @handleClose="handleClose"
      @saveData="saveData"
      :initialData="addOrEditData"
    ></add-or-edit>
  </div>
</template>

<script>
import StudentSelect from "./components/StudentSelect";
import AddOrEditSpecialStudents from "./components/AddOrEditSpecialStudents";
export default {
  name: "",
  components: {
    StudentSelect,
    "add-or-edit": AddOrEditSpecialStudents
  },
  props: {},
  data() {
    return {
      requestData: {
        schoolId: parseInt(this.$store.state.schoolId),
        pageSize: 20,
        pageNum: 1,
        className: "", //班级名称
        classTeacher: "", //老师名称
        emergencyContactName: "" //紧急联络人
      },
      tableData: [],
      total: 0,
      searchParams: {
        studentId: ""
      },
      drawerShow: false, //新增或修改抽屉
      drawerType: "", //新增或修改
      idsList: [], //选中用于删除的id数组
      addOrEditData: {
        studentId: "", //学生id
        className: "", //班级名称
        gender: "", //性别
        dateBirth: "", //出生日期
        classTeacher: "", //班主任
        classPhoneNumber: "", //班主任手机号
        homeAddress: "", //班主任住址
        emergencyContactName: "", //紧急联系人姓名
        emergencyContactPhone: "", //紧急联系人电话
        specificPhysicalCondition: "", //特殊体质情况
        currentCituation: "", //目前情况
        timeOnsetDiagnosis: "", //初发病确诊时间
        timeLastEpisode: "", //最近发病时间
        incidence: "", //发病情况
        parentalRequirements: "", //家长要求
        schoolRequirements: "", //学校要求
        proofOfParentalDisclaimer: "", //家长免责证明
        instructionManual: "" //备注说明
      }
    };
  },
  watch: {},
  computed: {},
  methods: {
    // 点击搜索按钮查询特异体质学生档案列表
    searchList() {
      this.requestData.pageNum = 1;
      this.getStudentList();
    },
    // 新增按钮
    addClick() {
      this.addOrEditData.schoolId = this.$store.state.schoolId;
      this.drawerShow = true;
      this.drawerType = "add";
    },
    // 修改按钮
    editClick(row) {
      this.addOrEditData = Object.assign({}, row);
      this.addOrEditData.dateBirth = this.addOrEditData.dateBirth * 1000;
      this.addOrEditData.timeLastEpisode =
        this.addOrEditData.timeLastEpisode * 1000;
      this.addOrEditData.timeOnsetDiagnosis =
        this.addOrEditData.timeOnsetDiagnosis * 1000;
      this.addOrEditData.studentId = this.addOrEditData.studentId + "";
      this.drawerShow = true;
      this.drawerType = "edit";
    },
    saveData(data) {
      let self = this;
      self.studentFile(data, function(val) {
        if (val) {
          self.drawerShow = false;
          self.refearshData();
          // 提交成功
          self.getStudentList();
        } else {
          // 提交失败
        }
      });
    },
    // 新增或修改学生档案
    async studentFile(data, callback) {
      let req = Object.assign({}, data);
      let res;
      if (this.drawerType == "add") {
        res = await this.$Http.addStudentFile(req, true);
      } else {
        res = await this.$Http.editStudentFile(req, true);
      }
      if (res.code == 200) {
        callback(true);
      } else if (res.code == 101) {
        callback(false);
      } else {
        callback(false);
      }
    },
    // 获取学生档案列表
    async getStudentList() {
      let req = Object.assign({}, this.requestData);
      let res = await this.$Http.getStudentList(req, true);
      if (res.code == 200) {
        this.tableData = res.data.list || [];
        this.total = res.data.total || [];
      } else {
        this.tableData = [];
        this.total = 0;
      }
    },
    // 初始化新增或修改数据
    refearshData() {
      this.addOrEditData = {
        studentId: "", //学生id
        className: "", //班级名称
        gender: "", //性别
        dateBirth: "", //出生日期
        classTeacher: "", //班主任
        classPhoneNumber: "", //班主任手机号
        homeAddress: "", //班主任住址
        emergencyContactName: "", //紧急联系人姓名
        emergencyContactPhone: "", //紧急联系人电话
        specificPhysicalCondition: "", //特殊体质情况
        currentCituation: "", //目前情况
        timeOnsetDiagnosis: "", //初发病确诊时间
        timeLastEpisode: "", //最近发病时间
        incidence: "", //发病情况
        parentalRequirements: "", //家长要求
        schoolRequirements: "", //学校要求
        proofOfParentalDisclaimer: "", //家长免责证明
        instructionManual: "" //备注说明
      };
    },
    // 关闭抽屉
    handleClose() {
      this.drawerShow = false;
    },
    // 删除按钮
    deleteClick(type, ids) {
      if (type == "all") {
        if (ids.length > 0) {
          this.deleteConfirm(ids);
        } else {
          this.$message({
            message: "请先选择所要删除的学生档案!"
          });
        }
      } else {
        this.deleteConfirm(ids);
      }
    },
    // 删除提示框
    deleteConfirm(ids) {
      this.$confirm("此操作将永久删除学生档案, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.deleteStudentFile({ ids: ids.toString() });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    async deleteStudentFile(data) {
      let req = Object.assign({}, data);
      let res = await this.$Http.deleteStudentFile(req);
      if (res.code == 200) {
        this.getStudentList();
      } else {
        this.$message({
          message: res.messsage || "删除失败",
          type: "error"
        });
      }
    },
    // 列表多选时
    selectActionData(selectData) {
      this.idsList = selectData.map((item) => {
        return item.id;
      });
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.requestData.pageNum = val;
      this.getStudentList();
    }
  },
  created() {},
  mounted() {
    this.getStudentList();
  }
};
</script>

<style lang="scss" scoped>
.select-input {
  width: 152px;
}
</style>
